import React, { Component } from 'react'
import Grid from '@material-ui/Core/Grid'
import Button from '@material-ui/Core/Button'
import {CardActions} from '@material-ui/core'
import Divider from '@material-ui/Core/Divider';
import {InteractionHandler} from '../InteractionHandler';


class ButtonGroup extends Component {
    constructor(props){
        super(props)
        this.onClick = this.onClick.bind(this)
    }

    onClick(e){
        console.log(e)
        if(e.InteractionElement && e.InteractionElement.Record == "1"){
            let props={
                "groupguid": this.props.groupguid,
                "authtoken": this.props.authtoken,
                "InteractionElement": e.InteractionElement
            }
            InteractionHandler(props)
            return true
        }
    }

    render() {
        var buttonArray = Object.keys(this.props.buttons).map((keyname, i)  => (
            <Grid item style={{padding:'0px'}}>
                        {this.props.buttons[keyname].Visible == "1" ? 
                            <Button 
                                variant="contained" 
                                color={this.props.buttons[keyname] == "secondary" ? "secondary" : "primary" }
                                classes={{root:'results-button'}}
                                onClick={() => this.onClick(this.props.buttons[keyname])}
                                href={(this.props.buttons[keyname].Link.indexOf('tel') == 0 || this.props.buttons[keyname].Link.indexOf('mail') == 0 || this.props.buttons[keyname].Link.indexOf('http') == 0) ? this.props.buttons[keyname].Link : '//' + this.props.buttons[keyname].Link} 
                                target="_blank"
                                style={{margin:'8px'}}>{this.props.buttons[keyname].Text}</Button>
                            : null }
                    </Grid>
        ))
        var divider = this.props.showDivider ? <Divider variant="middle" style={{marginBottom: '20px', marginLeft:'25%', marginRight:'25%'}}/> : <span style={{marginBottom:'20px'}}></span>
        return(
            <div style={{marginBottom:'25px'}} id="buttonGroup">
                {divider}
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="stretch"
                    noWrap
                    spacing={2}>
                    {buttonArray}

                </Grid>
        </div> 
        )
    }
}

export default ButtonGroup